import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Protocol, SwapRouter, Trade } from '@uniswap/router-sdk';
import { TradeType } from '@uniswap/sdk-core';
import { Route as V2RouteRaw } from '@uniswap/v2-sdk';
import { Route as V3RouteRaw } from '@uniswap/v3-sdk';
import _ from 'lodash';
import { CurrencyAmount } from '..';
export function buildTrade(tokenInCurrency, tokenOutCurrency, tradeType, routeAmounts) {
  var _$partition = _.partition(routeAmounts, function (routeAmount) {
    return routeAmount.protocol == Protocol.V3;
  }),
      _$partition2 = _slicedToArray(_$partition, 2),
      v3RouteAmounts = _$partition2[0],
      v2RouteAmounts = _$partition2[1];

  var v3Routes = _.map(v3RouteAmounts, function (routeAmount) {
    var route = routeAmount.route,
        amount = routeAmount.amount,
        quote = routeAmount.quote; // The route, amount and quote are all in terms of wrapped tokens.
    // When constructing the Trade object the inputAmount/outputAmount must
    // use native currencies if specified by the user. This is so that the Trade knows to wrap/unwrap.

    if (tradeType == TradeType.EXACT_INPUT) {
      var amountCurrency = CurrencyAmount.fromFractionalAmount(tokenInCurrency, amount.numerator, amount.denominator);
      var quoteCurrency = CurrencyAmount.fromFractionalAmount(tokenOutCurrency, quote.numerator, quote.denominator);
      var routeRaw = new V3RouteRaw(route.pools, amountCurrency.currency, quoteCurrency.currency);
      return {
        routev3: routeRaw,
        inputAmount: amountCurrency,
        outputAmount: quoteCurrency
      };
    } else {
      var _quoteCurrency = CurrencyAmount.fromFractionalAmount(tokenInCurrency, quote.numerator, quote.denominator);

      var _amountCurrency = CurrencyAmount.fromFractionalAmount(tokenOutCurrency, amount.numerator, amount.denominator);

      var routeCurrency = new V3RouteRaw(route.pools, _quoteCurrency.currency, _amountCurrency.currency);
      return {
        routev3: routeCurrency,
        inputAmount: _quoteCurrency,
        outputAmount: _amountCurrency
      };
    }
  });

  var v2Routes = _.map(v2RouteAmounts, function (routeAmount) {
    var route = routeAmount.route,
        amount = routeAmount.amount,
        quote = routeAmount.quote; // The route, amount and quote are all in terms of wrapped tokens.
    // When constructing the Trade object the inputAmount/outputAmount must
    // use native currencies if specified by the user. This is so that the Trade knows to wrap/unwrap.

    if (tradeType == TradeType.EXACT_INPUT) {
      var amountCurrency = CurrencyAmount.fromFractionalAmount(tokenInCurrency, amount.numerator, amount.denominator);
      var quoteCurrency = CurrencyAmount.fromFractionalAmount(tokenOutCurrency, quote.numerator, quote.denominator);
      var routeV2SDK = new V2RouteRaw(route.pairs, amountCurrency.currency, quoteCurrency.currency);
      return {
        routev2: routeV2SDK,
        inputAmount: amountCurrency,
        outputAmount: quoteCurrency
      };
    } else {
      var _quoteCurrency2 = CurrencyAmount.fromFractionalAmount(tokenInCurrency, quote.numerator, quote.denominator);

      var _amountCurrency2 = CurrencyAmount.fromFractionalAmount(tokenOutCurrency, amount.numerator, amount.denominator);

      var _routeV2SDK = new V2RouteRaw(route.pairs, _quoteCurrency2.currency, _amountCurrency2.currency);

      return {
        routev2: _routeV2SDK,
        inputAmount: _quoteCurrency2,
        outputAmount: _amountCurrency2
      };
    }
  });

  var trade = new Trade({
    v2Routes: v2Routes,
    v3Routes: v3Routes,
    tradeType: tradeType
  });
  return trade;
}
export function buildSwapMethodParameters(trade, swapConfig) {
  var recipient = swapConfig.recipient,
      slippageTolerance = swapConfig.slippageTolerance,
      deadline = swapConfig.deadline,
      inputTokenPermit = swapConfig.inputTokenPermit;
  return SwapRouter.swapCallParameters(trade, {
    recipient: recipient,
    slippageTolerance: slippageTolerance,
    deadlineOrPreviousBlockhash: deadline,
    inputTokenPermit: inputTokenPermit
  });
}